/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Guide_Save_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to save guide: {error}" |
*
* @param {Knp_Guide_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_save_failed = /** @type {((inputs: Knp_Guide_Save_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Save_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’enregistrement du guide : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Leitfaden konnte nicht gespeichert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile salvare la guida: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось сохранить руководство: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo guardar la guía: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`指南保存失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ガイドの保存に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`गाइड को सहेजने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao salvar o guia: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to save guide: ${i?.error}`)
});